
angular.module('trainerWebApp.services').factory('sorting', function () {
  function sortByName (propertyName) {
    propertyName = propertyName || 'name';
    return function (a,b) {
      return a[propertyName].toLowerCase()  < b[propertyName].toLowerCase()  ? -1 : 1;
    }
  }

  if (!singleton){
    var singleton = {
      byName: sortByName
    };
  }

  return singleton;
});
